import { BaseVo } from "./baseVo";
import language from "@/language";
export class simpleVo extends BaseVo{

  get id(){
    return this.$data.id;
  }

  get cover(){
    return this.$data.cover;
  }

  get name(){
    return language.text(this.$data.name.cn,this.$data.name.en);
  }

  get artist(){
    return this.$data.artist ? language.text(this.$data.artist.cn,this.$data.artist.en) : "";
  }

  get cates(){
    return this.$data.cates;
  }

  get cateText(){
    let str = [];
    for(let i in this.cates){
      str.push(language.text(this.cates[i].cn,this.cates[i].en));
    }
    return str.join("、");
  }

}

export class cateVo extends BaseVo{

  get id(){
    return this.$data.id;
  }

  get name(){
    return language.text(this.$data.name.cn,this.$data.name.en);
  }

}

export class infoVo extends simpleVo{


  get isbn(){
    return this.$data.isbn;
  }
  get requestCode(){
    return language.text(this.$data.requestCode.cn,this.$data.requestCode.en);
  }
  get remark(){
    return language.text(this.$data.keyword.cn,this.$data.keyword.en);
  }
  get summary(){
    return language.text(this.$data.summary.cn,this.$data.summary.en);
  }


}



// WEBPACK FOOTER //
// ./src/vo/bookVo.js